import React from 'react'
import getTranslationTime from '../../Translation/func/getTranslationTime'

const EditEventFormPrintDate = ({eventData, currentLang, timezone, debug}) => {
    const { date } = eventData.date
    const { event_time_start, event_time_end } = eventData
    let time = ''

    if(event_time_start) {
        time += 'von ' + getTranslationTime('time', timezone, currentLang,  event_time_start, debug, "", "Uhr")
    }

    if(event_time_end) {
        time += ' bis ' + getTranslationTime('time', timezone, currentLang, event_time_end, debug, "", "Uhr")
    }
    
    if(date) {
        return (
            <div className="container-1-2 margin-bottom">
                <span className="text-regular">Datum:</span> 
                <span className="text-small-light">{getTranslationTime('dateWithDay', timezone, currentLang, date, debug)}, {time}</span>
            </div>
        )
    } else {
        return ''
    }
}

export default EditEventFormPrintDate